<script setup lang="ts">
import type { StatsData } from '~/utils/crystallize/pieces'

const { stat } = defineProps<{
  stat: StatsData['values'][number]
}>()

const value = computed(() => stat.value.toLocaleString('nb-NO'))
</script>

<template>
  <div class="flex flex-col items-center">
    <strong class="title-xxl">
      {{ value }}{{ stat.exact ? '' : '+' }}
    </strong>
    <p class="title-quote lowercase !font-light" v-text="stat.label" />
  </div>
</template>
